// Add your custom JS here.



// Esperem que la font carregui i mesurem amplada
window.addEventListener('load', () => {


});

